// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a04ae9d0","884":"127244b2"}[chunkId] + ".chunk.js";
};